module.exports = __webpack_public_path__ + "static/fonts/Fact-Regular.a28865b.woff2";